const Responsive_Course_Exam_Instructions = () => {
  return (
    <div>
      <h1>Responsive Course Exam Instructions</h1>
    </div>
  );
};
export default Responsive_Course_Exam_Instructions;
